import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

/* components */
import SelectCount from 'components/ui/Dropdown/Count/SelectCount'

/* style */
import classes from './Menu.module.scss'


const Menu = (
  {
    countAdults,
    countChildren,
    onChange,
  },
) => {
  const { t } = useTranslation('booking_volunteering')

  return (
    <>
      <div className="d-flex justify-content-around">
        <SelectCount
          min={1}
          title="adultsMenu"
          name="countAdults"
          value={countAdults}
          onChange={onChange}
        />
        <SelectCount
          title="childrenMenu"
          name="countChildren"
          value={countChildren}
          onChange={onChange}
        />
      </div>
      <div className={classes.description}>
        {t('kidsDiscountRemark')}
      </div>
    </>

  )
}

Menu.propTypes = {
  countAdults: PropTypes.number,
  countChildren: PropTypes.number,
  onChange: PropTypes.func,
}

Menu.defaultProps = {}

export default Menu
